<!--
 * @Author: Niklaus
 * @Date: 2026-04-27 09:56:55
 * @LastEditTime: 2026-05-08 11:48:41
 * @LastEditors: Niklaus
 * @Description: 繁星空间房间管理- G座12层及17层部分房间
-->
<template>
    <div>
        <contract-comp deptName="崂山书院文化发展公司"></contract-comp>
    </div>
</template>

<script>
import ContractComp from './../contract/ContractComp.vue'
import { getDictionary } from "@/api/system/dictbiz";
export default {
    components: { ContractComp },

    data() {
        return {
            deptArray: []
        }
    },

    // created() {
    //     getDictionary({ code: "contractCreateDept" }).then(res => {
    //         this.deptArray = res.data.data;
    //     });
    // }
}
</script>

<style scoped></style>